import React, { useState, useEffect } from "react";
import "./VideoSelectionModal.css";
import BackArrow from "../../assets/images/BackArrow.svg";
import SearchIcon from "../../assets/images/SearchIcon.svg";
import TickIcon from "../../assets/images/tickIcon.svg";
import { videoCreatorEndPoint } from "../../Constants/constants";
import { callApi } from "../../utils/apiService";
import { useUser } from "../../Context/UserContext";
import { formatDate } from "../../utils/helpers";

const MOCK_VIDEOS = [
  {
    id: 1,
    title: "FULL GANGA AARTI VARANASI | BANARAS GHAT AARTI",
    date: "Oct 24, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=300",
  },

  {
    id: 2,
    title: "Astrological Lighting Tips for Compact Studios",
    date: "Oct 18, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=300",
  },

  {
    id: 3,
    title: "Unlocking The Mysteries of Ketu",
    date: "Oct 18, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=300",
  },

  {
    id: 4,
    title: "Significance of Lighting a Diya",
    date: "Oct 15, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=300",
  },
];

export default function VideoSelectionModal({ onClose, onSelect }) {
  const [selected, setSelected] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [videoList, setVideoList] = useState([]);
  const { user } = useUser();
  const clearAll = () => {
    setSelected(null);
    setSearchText("");
  };
  const filteredVideos = videoList.filter((video) =>
    video.title.toLowerCase().includes(searchText.toLowerCase()),
  );

  const fetchVideoList = async () => {
    try {
      const response = await callApi(
        `${videoCreatorEndPoint}creatorData/${user?.id}/videos`,
        "GET",
      );
      if (response?.status) {
        setVideoList(response?.data?.videos || []);
      }
    } catch (err) {}
  };

  useEffect(() => {
    fetchVideoList();
  }, []);

  return (
    <div className="modal-overlay">
      <div className="video-modal">
        <div className="video-select-link">
          <img src={BackArrow} alt="back-arrow" onClick={onClose} />
          <h3>Add your video link</h3>
        </div>
        <div className="search-input-wrapper">
          <img src={SearchIcon} alt="search" className="search-input-icon" />

          <input
            type="text"
            placeholder="Search your list..."
            value={searchText}
            className="search-text-input"
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <h6 className="list-label">LIST ({filteredVideos?.length})</h6>

        <div className="video-list">
          {filteredVideos.map((video) => (
            <div
              className={`video-item ${
                selected?.id === video.id ? "selected" : ""
              }`}
              key={video.id}
              onClick={() => setSelected(video)}
            >
              <img src={video.thumbnailImage} alt="" />

              <div>
                <h4>{video.title}</h4>
                <p>{formatDate(video.createdAt)}</p>
              </div>

              <p
                className={`custom-radio ${
                  selected?.id === video.id ? "checked" : ""
                }`}
              >
                {selected?.id === video.id && (
                  <img className="radio-check" src={TickIcon} alt="tick" />
                )}
              </p>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <span>{selected ? "1 VIDEO SELECTED" : "0 VIDEO SELECTED"}</span>

          <button onClick={clearAll}>CLEAR ALL</button>
        </div>

        <button className="add-video-btn" onClick={() => onSelect(selected)}>
          Add Video →
        </button>
      </div>
    </div>
  );
}
